import { z } from 'zod';

/** A language in the platform catalog (the per-DB `locales` table). */
export interface Language {
  code: string;
  name: string;
  nativeName: string;
  isRtl: boolean;
}

/** Tenant language configuration returned by GET /i18n/languages. */
export interface LanguagesResponse {
  /** Every language available in the catalog. */
  catalog: Language[];
  /** Codes the tenant has enabled for its content. */
  enabled: string[];
  /** The tenant's default content language (the base-column language). */
  default: string;
}

/** BCP-47-ish code: 2–3 letter primary subtag + optional region/script. */
const LOCALE_CODE = z.string().regex(/^[a-z]{2,3}(-[A-Za-z0-9]{2,8})?$/, 'invalid locale code');

export const LanguagesConfigUpdateSchema = z.object({
  enabled: z.array(LOCALE_CODE).min(1).max(40),
  default: LOCALE_CODE,
});
export type LanguagesConfigUpdate = z.infer<typeof LanguagesConfigUpdateSchema>;
